module.exports = __webpack_public_path__ + "static/media/serverestlogo1branco.7e020988.png";